<template>
<div>
  <v-row align="center" justify="center">
    <v-col cols="12" sm="8" md="4">
      <v-card class="elevation-5 pt-5 pb-10 pl-5 pr-5">
        <v-img height="120" contain src="../assets/Pelican_LogoB.png"></v-img>
        <v-card-title v-text="card.cardTitle" class="font-weight-black justify-center"></v-card-title>
        <v-card-subtitle v-text="card.cardSubTitle" class="font-weight-black text-center mt-0"></v-card-subtitle>
        </br></br></br>
        <v-btn color="primary" x-large @click="btnPostData()">
          <font face="微軟正黑體" size="5">確定送出</font>
        </v-btn>
        </br></br>
        </br></br>
      </v-card>
    </v-col>
  </v-row>


</div>
</template>

<script>
export default {
  data() {
    return {
      assign_date: new Date(new Date().getTime() + 3 * 24 * 60 * 60 * 1000),
      testTime: new Date().getTime(),
      card: {
        cardTitle: "",
        cardSubTitle: "",
      },
      firstName: 'Dawei',
      lastName: 'Lou',
      fullName: '',
      Roundtrip_type: false,
    };
  },
  created() {

  },
  methods: {
    btnPostData: function() {
      let posturl = 'http://query1.e-can.com.tw:8080/EC_H2C_WS/Service_H2C_EC.asmx';
      let axiosConfig = {
        headers: {
          'Content-Type': 'text/xml'
        }
      };
      let XMLdata =
        'PD94bWwgdmVyc2lvbiA9ICIxLjAiIGVuY29kaW5nID0gIlVURi04Ij8+PHJvb3Q+PFZFTkRPUkNPREU+PEtFWUNPREU+PCFbQ0RBVEFbbURrSldyd05SaVl6b0pjS2t4TGppQT09XV0+PC9LRVlDT0RFPjwvVkVORE9SQ09ERT48T1JERVJfRE9DPjxPUkRFUj48RUNOTz42MjI8L0VDTk8+PE9ETk8+PC9PRE5PPjxTVE5PPkswMDAwMDQ8L1NUTk8+PEFNVD4wPC9BTVQ+PENVVEtOTT48IVtDREFUQVvmuKzoqaZdXT48L0NVVEtOTT48Q1VUS1RMPjA5MDkwMTYxODI8L0NVVEtUTD48UFJPRE5NPjA8L1BST0ROTT48RUNXRUI+PCFbQ0RBVEFb5Y+w54Gj5a6F6YWN6YCaXV0+PC9FQ1dFQj48RUNTRVJURUw+MDI2NjE4MTgxODwvRUNTRVJURUw+PFJFQUxBTVQ+MTAwMDA8L1JFQUxBTVQ+PFRSQURFVFlQRT4zPC9UUkFERVRZUEU+PFNFUkNPREU+OTE4PC9TRVJDT0RFPjxFRENOTz5EMTU8L0VEQ05PPjxWRU5ET1I+PCFbQ0RBVEFb5Y+w54Gj5a6F6YWN6YCaXV0+PC9WRU5ET1I+PFZFTkRPUk5PPjk3NzQ0NjQ4ODk0NDwvVkVORE9STk8+PE9SREVSTU9ERT5BPC9PUkRFUk1PREU+PC9PUkRFUj48L09SREVSX0RPQz48T1JERVJDT1VOVD48VE9UQUxTPjE8L1RPVEFMUz48L09SREVSQ09VTlQ+PC9yb290Pg=='
      let postdata = '<?xml version="1.0" encoding="utf-8"?>' +
        '<soap-env:Envelope xmlns:soap-env="http://schemas.xmlsoap.org/soap/envelope/">' +
        '<soap-env:Body>' +
        '<ORDERS_ADD xmlns="http://tempuri.org/">' +
        '<f>' +
        XMLdata +
        '</f>' +
        '</ORDERS_ADD>' +
        '</soap-env:Body>' +
        '</soap-env:Envelope>';
      console.log('posturl：'+posturl);
      console.log('axiosConfig：'+axiosConfig);
      console.log('XMLdata：'+XMLdata);
      console.log('postdata：'+postdata);
      this.$axios.post(posturl, postdata, axiosConfig).then((response) => {
          console.log(response);
          console.log(response.data);
        })
        .catch((error) => {
          console.log(error)
        });
    },
  },
}
</script>
